import { mockBuilder } from '../../utils/builderHelper.es.js';
import { ReleaseBalance } from './ReleaseBalance.es.js';

/** @module Mocks */ /** typedoc */
function aReleaseBalance() {
    return mockBuilder(new ReleaseBalance())
        .withValue(9.99)
        .withCurrencyCode('USD')
        .withCurrencySymbol('$')
        .withTotalAmountReceived(123);
}

export { aReleaseBalance };
